<template>
  <div class="page">
    <div class="count-down">
      <span @click="skip">跳过{{countDown}}S</span>
    </div>
    <div class="title">
      <div class="title-content">绑定微信</div>
      <div class="title-content">并关注天美贷官方微信公众号</div>
    </div>
    <div class="tips">及时掌握您的天美贷账号动态，享专属福利活动！</div>
    <img class="banner" src="./images/bind_wechat_banner.png">
    <div class="bind-card">
      <img src="./images/bind_wechat_logo.png" class="logo">
      <nd-button class="bind-button" data-sensors-click @click="handleWxBind">立即绑定</nd-button>
      <div class="bind-bottom-tips" @click="skip">稍后通过「我的-账号与安全」进行绑定</div>
    </div>
    <div class="code-box">
      <div class="code-img">
        <img src="./images/img_QR@2x.png">
        <p class="code-text">天美贷公众号</p>
      </div>
      <div class="code-right">
        <div class="right-box right-download" @click="handleDownload">
          <p class="right-p1">点击下载二维码至相册</p>
          <p class="right-p2">微信扫一扫识别关注公众号</p>
        </div>
        <div class="right-box right-copy" @click="copy">
          <p class="right-p1">点击复制微信号   ct_tmd</p>
          <p class="right-p2">微信搜索关注公众号</p>
        </div>
      </div>
    </div>

    <nd-dialog v-model="showTips" @confirm="copyLink" :closeBtn="false" confirmText="复制链接">
      <div class="unbind-dialog center">
        <div class="dialog-title">提示</div>
        <div class="description">
          复制链接在微信内打开
        </div>
      </div>
    </nd-dialog>

  </div>
</template>

<script>
import { copyToClipbord, getKey } from '@/assets/utils'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
import { mapActions } from 'vuex'
import bind from '@/assets/bindWechat.js'
export default {
  name: 'bind_wechat',
  async mounted () {
    this.$bus.$emit('ready')
    this.countDownAction()
  },
  mixins: [bind],
  data () {
    return { 
      timer: null,
      countDown: 5,
      appId: '',
      showTips: false
    }
  },
  beforeRouteLeave (to, from, next) {
    clearInterval(this.timer)
    next()
  },
  methods: {
    ...mapActions('wxBind', ['getTokenX']),

    handleWxBind () {
      clearInterval(this.timer)
      if (!this.isWechat) {
        this.showTips = true
      } else {
        this.toBind()
      }
    },
    skip () {
      this.$router.replace('/')
    },
    copyLink () {
      const userInfo = getKey('userInfo')
      copyToClipbord(`${window.location.origin}/user/wechat/bind?token=${userInfo.token}`)
      this.$message('复制成功')
    },
    copy () {
      copyToClipbord('ct_tmd')
      this.$message('已复制到剪贴板')
    },
    
    saveSuccess () {
      this.$message('已保存至系统相册')
    },
    handleDownload () {
      this.downloadImage('http://ndmicro-tmd.oss-cn-beijing.aliyuncs.com/authenticate/1_15683410918_Web_1605512702096', 'qrcode')
    },
    async downloadImage (imgsrc, name) {
      if (hasNativeMethod('saveQRCode')) {
        const res = await jsBridge('saveQRCode', {
          url: imgsrc,
          name: name
        })
        if (res && res.code === 'OK') {
          this.saveSuccess()
        }
      } else {
        this.$message('请长按左侧二维码保存')
      }
    },
    countDownAction () {
      console.log('begin count down')
      this.timer = setInterval(() => {
        if (this.countDown <= 1) {
          clearInterval(this.timer)
          this.skip()
        } else {
          this.countDown--
        }
      }, 1000)
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page {
  background: #f7f7f7;
  padding: 0 40px;
  .unbind-dialog {
    padding-top: 10px;
    padding: 0 48px;
    padding-bottom: 80px;
    font-family: PingFangSC-Regular,PingFang SC;
    &.center {text-align: center;}
    .dialog-title {
      font-size: 42px;
                height: 72px;
                line-height: 72px;
                font-family: PingFangSC-Semibold,PingFang SC;
                font-weight: 600;
    }
    .description { 
      font-size: 30px;
      height: 32px;
      line-height: 1.5em;
      margin-top: 22px;
      font-weight: 400;
    }
  }
  .count-down {
    padding-top: 83px;
    text-align: end;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 40px;
    span {
      border-bottom: 1px solid #666;
    }
  }
  .title {
    padding-top: 52px;
    .title-content {
        font-size: 42px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 59px;
      }
  }
  .tips {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 40px;
    margin-top: 4px;
  }
  .banner {
    background-size: cover;
    width: 100%;
    margin-top: 20px;
  }
  .bind-card {
    background: #fff;
    border-radius: 20px;
    width: 100%;
    height: 569px;
    text-align: center;
    margin-top: 20px;
    .logo {
      width: 234px;
      height: 111px;
      margin-top: 80px;
    }
    .bind-button {
      width: 590px;
      height: 94px;
      margin: 38px auto;
    }
    .bind-bottom-tips {
      height: 40px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FF4633;
      line-height: 40px;
    }
  }
  .code-box{
    margin-top: 20px;
    background-color: #fff;
    border-radius: 30px;
    padding: 40px 30px;
    display: flex;
    justify-content: space-between;
    color: #333333;
    .code-img{
      width: 160px;
      background-color: #F7F7F7;
      border-radius: 8px;
      padding: 10px;
      text-align: center;
      img{
        width: 140px;
        height: 140px;
      }
      .code-text{
        font-size: 20px;
        line-height: 28px;
        margin-top: 4px;
      }
    }
    .code-right{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 433px;
      .right-box{
        background-color: #F7F7F7;
        background-position: calc(100% - 20px) center;
        background-size: 30px;
        background-repeat: no-repeat;
        padding: 10px 30px;
        border-radius: 8px;
        .right-p1{
          font-size: 26px;
          font-weight: 500;
          line-height: 37px;
        }
        .right-p2{
          font-size: 20px;
          color: #9C9C9C;
          line-height: 28px;
        }
        &.right-download{
          background-image: url(./images/icon_download@2x.png);
        }
        &.right-copy{
          background-image: url(./images/icon_copy@2x.png);
        }
      }
    }
  }
}
</style>